interface IGST_FORMULA {
  amount: number;
  gstRate: string;
  isGSTIncluded: string;
  isSameState: string;
}

export const GST_FORMULA = ({
  amount,
  gstRate,
  isGSTIncluded,
  isSameState,
}: IGST_FORMULA) => {
  const amountInput = Number(amount);
  const gstRateNumber = Number(gstRate) / 100;

  let baseAmount = 0;
  let totalGSTAmount = 0;
  let totalAmount = 0;
  let cGST = 0;
  let sGST = 0;
  let iGST = 0;

  if (isGSTIncluded === 'yes') {
    // GST is included in the amount
    totalAmount = amountInput;
    baseAmount = Math.round((amountInput / (1 + gstRateNumber)) * 100) / 100;
    totalGSTAmount = totalAmount - baseAmount;
  } else {
    // GST is not included in the amount
    baseAmount = amountInput;
    totalGSTAmount = baseAmount * gstRateNumber;
    totalAmount = baseAmount + totalGSTAmount;
  }

  if (isSameState === 'yes') {
    // Same state - use CGST + SGST (each 2.5% for 5% total)
    cGST = sGST = totalGSTAmount / 2;
    iGST = 0;
  } else {
    // Different state - use IGST (5% total)
    iGST = totalGSTAmount;
    cGST = sGST = 0;
  }

  return {
    amountOutput: baseAmount.toFixed(2),
    CGST: cGST.toFixed(2),
    SGST: sGST.toFixed(2),
    IGST: iGST.toFixed(2),
    totalAmount: totalAmount.toFixed(2),
  };
};
